/*
 * @Description:dome
 * @Author: 山淑兰
 * @Date: 2019-12-26 10:32:28
 * @LastEditTime : 2019-12-27 23:43:09
 * @LastEditors  : 山淑兰
 */

import { Get, Pick, Delete, Put, Post } from "@/api/utils";
import { GetContentAuditListDto, GetWeightListDto } from "./index.dto";

export default {
  /**
   * @title 获得频道列表
   * @date 2019-04-16
   */
  getChannelList(body: any) {
    const params = Pick(body, GetContentAuditListDto);
    return Get({ url: "/ratings/list", params });
  },
  /**
   * @title 获得收视率列表
   * @date 2019-04-16
   */
  getRatingList(body: GetWeightListDto) {
    const params = Pick(body, GetWeightListDto);
    return Get({ url: "/v1/weight", params });
  },
  /**
   * @title 更新收视率
   * @date 2019-04-16
   */
  updateRating(body: any) {
    const params = Pick(body, GetContentAuditListDto);
    return Put({ url: "", params });
  },
  /**
   * @title 创建收视率
   * @date 2019-04-16
   */
  createRating(body: any) {
    const params = Pick(body, GetContentAuditListDto);
    return Post({ url: "", params });
  },
  /**
   * @title 删除收视率
   * @date 2019-04-16
   */
  deleteRating(body: any) {
    const params = Pick(body, GetContentAuditListDto);
    return Delete({ url: "", params });
  },
  /**
   * @title 收视率曲线
   * @date 2019-04-16
   */
  getRatingChart(body: any) {
    // getRatingChart(body: GetContentAuditListDto) {
    const params = Pick(body, GetContentAuditListDto);
    return Get({ url: "/v1/icon", params });
  },
};
